import React from 'react';
import Nav from '../components/Nav';
import Header from '../components/Header';
import Services from '../components/Services';
import Portofolio from '../components/Portofolio';
import Footer from '../components/Footer';
import About from '../components/About';
import TeamSection from '../components/Team';
import Milestone from '../components/Milestone';
import OurClient from '../components/OurClient';
import CTA from '../components/CTA';
import Models from '../components/Models';

function HomePage() {
  return (
    <>
      <Nav />
      <Header />
      <About />
      <Services />
      <Milestone />
      <OurClient />
      <Portofolio />
      <Models />
      <TeamSection />
      <CTA />
      <Footer />
    </>
  );
}

export default HomePage;
